import { admin, palette, typography } from '../../../styles/tokens';
import ChecklistRow from './ChecklistRow';
import type { ResolvedItem } from '../hooks/useSetupGuideState';

interface ChecklistSectionProps {
  title: string;
  items: ResolvedItem[];
  onItemClick: (item: ResolvedItem) => void;
}

export default function ChecklistSection({ title, items, onItemClick }: ChecklistSectionProps) {
  return (
    <section style={{ marginBottom: 32 }}>
      <div style={{ borderTop: `1px solid ${palette.g150}`, paddingTop: 20, marginBottom: 12 }}>
        <h2
          style={{
            margin: 0,
            fontSize: typography.size.heading,
            fontWeight: typography.weight.semibold,
            color: admin.header,
            letterSpacing: '-0.01em',
          }}
        >
          {title}
        </h2>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        {items.map((item, i) => (
          <ChecklistRow key={item.config.key} item={item} index={i} onClick={onItemClick} />
        ))}
      </div>
    </section>
  );
}
